import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";
import { Reveal } from "@/components/motion/Reveal";

// Bento layout spans + alternating diagonal clips echoing the split-house logo
const layout = [
  { span: "md:col-span-2 md:row-span-2", clip: "clip-corner", h: "h-full min-h-[260px] md:min-h-[520px]" },
  { span: "", clip: "", h: "h-[240px]" },
  { span: "", clip: "clip-corner-tl", h: "h-[240px]" },
  { span: "", clip: "clip-corner-tl", h: "h-[240px]" },
  { span: "", clip: "", h: "h-[240px]" },
  { span: "md:col-span-2", clip: "clip-corner", h: "h-[240px]" },
  { span: "md:col-span-2", clip: "clip-corner-tl", h: "h-[240px]" },
];

export default function Gallery() {
  return (
    <section id="gallery" className="relative py-20 md:py-32 bg-offwhite" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14 md:mb-16">
          <div className="max-w-xl">
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-petrol mb-4">Our Work</p>
            <h2 className="font-display font-extrabold text-ink text-3xl md:text-5xl tracking-tight leading-tight">
              Before & after, done with care.
            </h2>
          </div>
          <p className="text-ink/60 font-light max-w-sm">
            A look at the repairs and clean-ups we deliver across Charlotte. Real spaces, real results.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 md:auto-rows-[248px]">
          {IMAGES.gallery.map((g, i) => {
            const l = layout[i] || {};
            return (
              <Reveal key={g.label} delay={(i % 3) * 0.08} className={l.span}>
                <motion.div
                  whileHover={{ scale: 0.985 }}
                  transition={{ duration: 0.4 }}
                  className={`group relative overflow-hidden rounded-2xl ${l.clip} ${l.h} h-full w-full`}
                  data-testid={`gallery-item-${i}`}
                >
                  <img
                    src={g.src}
                    alt={g.label}
                    className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-[900ms] ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-petrol/85 via-petrol/10 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-500" />
                  <div className="absolute inset-x-0 bottom-0 p-5 translate-y-1 group-hover:translate-y-0 transition-transform duration-500">
                    <span className={`inline-block mb-2 rounded-full px-2.5 py-1 text-[10px] font-bold tracking-wider uppercase ${g.tag === "Repairs" ? "bg-mustard text-ink" : "bg-offwhite text-petrol"}`}>
                      {g.tag}
                    </span>
                    <p className="font-display font-bold text-offwhite text-lg leading-tight">{g.label}</p>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
